import { render } from "./Splash.vue?vue&type=template&id=088c2df8&ts=true"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__